export default __webpack_public_path__ + "static/media/photo--sm--126.a8e629ec.jpg";